// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oSiud","type":"styles_type__3c2LC","choices":"styles_choices__31hT7"};